import { ArrowLeftToLine } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArrowLeftToLineIcon = createLucideIcon(ArrowLeftToLine);
